import { fetchHTML } from '@utils';
import { pubsub } from '@services';

class CartSummary extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionFetch;

    this.unsubscribeCartUpdating = pubsub.subscribe('cart:updating', () => {
      this.toggleLoading(true);
    });
    this.unsubscribeCartUpdated = pubsub.subscribe('cart:updated', () => {
      this.fetchCartSummary();
    });
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdating();
    this.unsubscribeCartUpdated();
  }

  /**
   * Fetch cart summary
   */
  async fetchCartSummary() {
    try {
      const html = await fetchHTML(`${Shopify.routes.root}?section_id=${this.sectionId}`);
      const target = html.querySelector('cart-summary');

      this.innerHTML = target.innerHTML;
    } catch (error) {
      console.error(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  /**
   * Toggle button loading
   * @param {boolean} isLoading - Whether to toggle the button loading state.
   */
  toggleLoading(isLoading) {
    this.submitButton = this.submitButton || this.querySelector('[type="submit"]');
    if (!this.submitButton) return;

    this.submitButton.classList.toggle('loading', isLoading);
    this.submitButton.disabled = isLoading;
  }
}

customElements.define('cart-summary', CartSummary);
